module.exports = __webpack_public_path__ + "static/media/spider_s.08d5d1c8.png";